import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DataFieldComponentBase } from './datafield-base-component';
import { DataField } from './models/datafield';


@Component({
    selector: 'ep-datafield-textbox',
    templateUrl: './datafield-textbox.component.html',
    inputs: ['isAlwaysEditable', 'datafield', 'formValidationGroup'],
    outputs: ['valueChanged'] // It's necessary to set this, because the valueChanged method is placed in the base-class and not inherited if this is not set.
    ,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, ReactiveFormsModule]
})

export class DataFieldTextBoxComponent extends DataFieldComponentBase {

    constructor() {
        super();
    }

    // Inherited properties - because of the lack of decorator-inheritance
    //@Input() public isAlwaysEditable: boolean;
    //@Input() public datafield: DataField;
    //@Input() public formValidationGroup: FormGroup;
    //@Input() public showError: boolean;

    get isValid() {
        if (this.formValidationGroup.disabled) {
            return true;
        }

        return this.formValidationGroup.controls[this.validationIdentifier].valid == true;
    }

    get errorText() {
        if (this.formValidationGroup.disabled) {
            return '';
        }

        if (this.formValidationGroup.controls[this.validationIdentifier].hasError('required')) {
            return 'This field is required'
        }

        if (this.formValidationGroup.controls[this.validationIdentifier].hasError('pattern')) {
            return this.datafield.RegExErrorMessage || `Invalid pattern - must match: ${this.datafield.RegEx}`; // If not error-message is given - use a generic error message...
        }

        return 'Unknown error';
    }
}
